import { HomeMemberChangePassword } from './HomeMemberChangePassword';
export default HomeMemberChangePassword;
